"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.RTW_FEEDBACK;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "",
  inline: false
};
var feedbackQuestions = [{
  prompt: "I thought that Workable was very easy to use",
  type: "radio",
  options: ["Strongly agree", "agree", "Neither agree nor disagree", "disagree", "Strongly disagree"],
  key: "easeofuse",
  optional: false,
  eval: function _eval(n, q) {
    return q.options[n];
  }
}, {
  prompt: "What did you find the most helpful about the Workable program?",
  type: "textarea",
  optional: true,
  key: "mostHelpful",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "What did you find the least helpful about the Workable program?",
  type: "textarea",
  optional: true,
  key: "leastHelpful",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "Do you have any suggested improvements to the Workable program?",
  type: "textarea",
  optional: true,
  key: "improvements",
  eval: function _eval(n) {
    return n;
  }
}];
var questions = (0, _utils.wrapBattery)(feedbackQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  return {
    RTW_FEEDBACK_1: answers[0],
    RTW_FEEDBACK_2: answers[1],
    RTW_FEEDBACK_3: answers[2],
    RTW_FEEDBACK_4: answers[3]
  };
}